import {
  DollarSign,
  Coins,
  FileText,
  CalendarDays,
  User,
  Tag,
  Boxes,
  Truck,
  CreditCard,
  Building2,
  Percent,
  ShieldCheck,
  Package,
  FilePlus,
  FileSearch,
  Hash,
  MapPin,
  List,
  ListOrdered,
  Files,
  Table,
  Phone,
  Mail,
  Briefcase,
  IdCard,
  Edit,
  Box,
  ScanBarcode,
  MoreHorizontal,
  Ruler,
  CheckCircle,
  PauseCircle,
  Store,
  ArrowDown01,
  ArrowUp01,
  Code,
  Printer,
  Network,
  Server,
  Search,
  AlertCircle,
  QrCode,
  RulerIcon,
  Scissors,
  Key,
  ArrowLeftRight,
  Lock,
  KeyRound,
  FileCheck,
  Clock,
  Settings,
  Route,
  Layers,
  XCircle,
  UserCheck,
  UserPlus,
  Scale,
  StepBack,
  Archive,
  Globe,
  Wallet,
  StickyNote,
  Terminal,
  Calculator,
  Radio,
  Bell,
  BellRing,
  Activity,
  Wifi,
  WifiOff,
  Zap,
  MessageSquare,
  TriangleAlert,
  RefreshCw,
  Timer,
  Filter,
  Utensils,
  UtensilsCrossed,
  ChefHat,
  HandPlatter,
  Coffee,
  Wine,
  Beer,
  Martini,
  CupSoda,
  GlassWater,
  Milk,
  Soup,
  Salad,
  Pizza,
  Sandwich,
  Beef,
  Ham,
  Drumstick,
  Fish,
  Egg,
  EggFried,
  Croissant,
  Cookie,
  CakeSlice,
  Dessert,
  IceCream,
  IceCreamBowl,
  Candy,
  Donut,
  Popcorn,
  Nut,
  Apple,
  Cherry,
  Grape,
  Citrus,
  Carrot,
  Wheat,
  Flame,
  Leaf,
  Vegan,
  Snowflake,
  Droplet,
} from 'lucide-react'; // 🔥 agregué también flechas extra por si necesitas

import { IconKey } from '../../../types/system/icons';

interface InputIconByKeyProps {
  iconKey: IconKey; // 👈 ahora está tipado
  className?: string;
}

const InputIconByKey: React.FC<InputIconByKeyProps> = ({
  iconKey,
  className = 'h-5 w-5 text-black dark:text-white',
}) => {
  const iconMap: Record<string, React.ReactNode> = {
    // Generales
    dollar: <DollarSign className={className} />,
    bill: <DollarSign className={className} />,
    coin: <Coins className={className} />,
    coins: <Coins className={className} />,
    cash: <Wallet className={className} />,

    document: <FileText className={className} />,
    calendar: <CalendarDays className={className} />,
    user: <User className={className} />,
    userCheck: <UserCheck className={className} />,
    userPlus: <UserPlus className={className} />,
    hash: <Hash className={className} />,
    address: <MapPin className={className} />,
    phone: <Phone className={className} />,
    email: <Mail className={className} />,
    briefcase: <Briefcase className={className} />,
    idCard: <IdCard className={className} />,
    edit: <Edit className={className} />,
    truck: <Truck className={className} />,
    more: <MoreHorizontal className={className} />,

    purchase: <Package className={className} />,
    settled: <FileCheck className={className} />,
    pendingPurchase: <Clock className={className} />,

    // Producto / Inventario
    product: <Box className={className} />,
    category: <Tag className={className} />,
    unit: <Boxes className={className} />,
    unitMeasure: <Ruler className={className} />,
    supplier: <Truck className={className} />,
    stock: <Package className={className} />,
    barcode: <ScanBarcode className={className} />,
    tag: <Tag className={className} />,
    id: <IdCard className={className} />,

    // Compra/Venta
    invoice: <FilePlus className={className} />,
    searchInvoice: <FileSearch className={className} />,
    payment: <CreditCard className={className} />,
    creditCard: <CreditCard className={className} />,
    transfer: <ArrowLeftRight className={className} />,

    // Configuraciones
    company: <Building2 className={className} />,
    discount: <Percent className={className} />,
    percentage: <Percent className={className} />,
    security: <ShieldCheck className={className} />,

    // Listas
    list: <List className={className} />,
    listOrdered: <ListOrdered className={className} />,
    files: <Files className={className} />,
    table: <Table className={className} />,

    // Estados
    check: <CheckCircle className={className} />,
    pause: <PauseCircle className={className} />,
    status: <CheckCircle className={className} />,

    // Services
    service: <Briefcase className={className} />,

    // Sucursal
    branch: <Store className={className} />,
    store: <Store className={className} />,

    // Movimientos de valores
    arrowDown: <ArrowDown01 className={className} />,
    arrowUp: <ArrowUp01 className={className} />,
    priceDown: <ArrowDown01 className={className} />,
    priceUp: <ArrowUp01 className={className} />,

    code: <Code className={className} />,

    printer: <Printer className={className} />,
    network: <Network className={className} />,
    port: <Server className={className} />,

    search: <Search className={className} />,
    filter: <Filter className={className} />,

    // Alias adicionales para compatibilidad
    building: <Building2 className={className} />,
    file: <FileText className={className} />,

    alert: <AlertCircle className={className} />,

    // Alertas
    warning: <TriangleAlert className={className} />,
    alertTriangle: <TriangleAlert className={className} />,

    // Recarga
    refresh: <RefreshCw className={className} />,
    reload: <RefreshCw className={className} />,
    sync: <RefreshCw className={className} />,

    qr: <QrCode className={className} />,
    layout: <RulerIcon className={className} />,
    scissors: <Scissors className={className} />,

    key: <Key className={className} />,
    lock: <Lock className={className} />,
    keyRound: <KeyRound className={className} />,
    settings: <Settings className={className} />,
    route: <Route className={className} />,
    categories: <Layers className={className} />,
    yes: <CheckCircle className={className} />,
    no: <XCircle className={className} />,

    clock: <Clock className={className} />,
    timer: <Timer className={className} />,
    shield: <ShieldCheck className={className} />,
    server: <Server className={className} />,

    // --- 🔥 NUEVOS ICONOS AGREGADOS ---
    layers: <Layers className={className} />,
    scale: <Scale className={className} />,
    ruler: <Ruler className={className} />,
    box: <Box className={className} />,
    stack: <StepBack className={className} />,
    archive: <Archive className={className} />,
    globe: <Globe className={className} />,
    note: <StickyNote className={className} />,

    // Caja
    terminal: <Terminal className={className} />,
    cashRegister: <Terminal className={className} />,
    cashSession: <Clock className={className} />,
    cashOpening: <Wallet className={className} />,
    cashClosing: <Archive className={className} />,
    cashAudit: <Scale className={className} />,
    calculator: <Calculator className={className} />,

    // Realtime
    realtime: <Radio className={className} />,
    channel: <Radio className={className} />,
    channels: <Radio className={className} />,

    notification: <Bell className={className} />,
    notifications: <Bell className={className} />,
    bell: <Bell className={className} />,
    bellRing: <BellRing className={className} />,

    activity: <Activity className={className} />,

    connected: <Wifi className={className} />,
    disconnected: <WifiOff className={className} />,

    event: <Zap className={className} />,
    events: <Zap className={className} />,

    message: <MessageSquare className={className} />,

    // 🍽️ Restaurante / alimentos y bebidas
    utensils: <Utensils className={className} />,
    utensilsCrossed: <UtensilsCrossed className={className} />,
    chefHat: <ChefHat className={className} />,
    platter: <HandPlatter className={className} />,
    roomService: <HandPlatter className={className} />,
    drinks: <CupSoda className={className} />,
    coffee: <Coffee className={className} />,
    tea: <Coffee className={className} />,
    wine: <Wine className={className} />,
    beer: <Beer className={className} />,
    cocktail: <Martini className={className} />,
    soda: <CupSoda className={className} />,
    water: <GlassWater className={className} />,
    juice: <Citrus className={className} />,
    milk: <Milk className={className} />,
    soup: <Soup className={className} />,
    salad: <Salad className={className} />,
    pizza: <Pizza className={className} />,
    sandwich: <Sandwich className={className} />,
    burger: <Sandwich className={className} />,
    meat: <Beef className={className} />,
    ham: <Ham className={className} />,
    chicken: <Drumstick className={className} />,
    fish: <Fish className={className} />,
    seafood: <Fish className={className} />,
    egg: <Egg className={className} />,
    breakfast: <EggFried className={className} />,
    bread: <Croissant className={className} />,
    bakery: <Croissant className={className} />,
    cookie: <Cookie className={className} />,
    cake: <CakeSlice className={className} />,
    dessert: <Dessert className={className} />,
    iceCream: <IceCream className={className} />,
    iceCreamBowl: <IceCreamBowl className={className} />,
    candy: <Candy className={className} />,
    donut: <Donut className={className} />,
    snack: <Popcorn className={className} />,
    popcorn: <Popcorn className={className} />,
    nuts: <Nut className={className} />,
    fruit: <Apple className={className} />,
    cherry: <Cherry className={className} />,
    grape: <Grape className={className} />,
    citrus: <Citrus className={className} />,
    vegetables: <Carrot className={className} />,
    carrot: <Carrot className={className} />,
    pepper: <Flame className={className} />,
    sauce: <Droplet className={className} />,
    grain: <Wheat className={className} />,
    grill: <Flame className={className} />,
    spicy: <Flame className={className} />,
    snowflake: <Snowflake className={className} />,
    package: <Package className={className} />,
    vegan: <Vegan className={className} />,
    vegetarian: <Leaf className={className} />,

    // Alias con el nombre original de lucide (por si se guardó así)
    cupSoda: <CupSoda className={className} />,
    glassWater: <GlassWater className={className} />,
    handPlatter: <HandPlatter className={className} />,
    cakeSlice: <CakeSlice className={className} />,
    eggFried: <EggFried className={className} />,
    leaf: <Leaf className={className} />,
    flame: <Flame className={className} />,
    apple: <Apple className={className} />,
    beef: <Beef className={className} />,
  };

  if (iconMap[iconKey]) return iconMap[iconKey];

  // Tolera claves guardadas en kebab-case (p. ej. "utensils-crossed" o
  // "cup-soda") convirtiéndolas a la clave camelCase equivalente.
  const camel = iconKey.replace(/-([a-z])/g, (_, c: string) => c.toUpperCase());
  return iconMap[camel] ?? null;
};

export default InputIconByKey;
